var products = new function () {

    this.selectedOptions = {}; // Store per variation so choices are not lost when changing dropdowns
    this.savedColourOptions = []; // Store per variation so choices are not lost when changing dropdowns
    this.currentVariation;
    this.productMinimumQuantity;
    this.statePages = [];

    this.setBullets = function (event, el) {
        $('.product__bullets').find('li').eq(5).nextAll().remove()
        if ($('.product-detail-bullets').find('li').length <= 6) {
            $('.product-detail-bullets').remove();
        } else {
            $('.product-detail-bullets').find('li').eq(6).prevAll().remove()
        }
    };

    this.doMoreInfo = function (event, el) {
        location.hash = $(el).attr('href').replace('#', '');
        this.doHashChange();

        var offset = 0;
        if ($('.product-tabs').is(':visible')) {
            offset = 60
        }
        $('html, body').animate({
            scrollTop: $('.product-tab-content').offset().top - offset
        }, 200);
    };
    this.getOptionalExtrasPrice = function () {
        var priceExc = 0,
            priceInc = 0,
            optionalExtras = [],
            optionalExtraIds = [];
        $('.optional-extras').find('.form-checkbox__checkbox').each(function (key) {
            if ($(this).is(':checked')) {
                priceExc += parseFloat($(this).data('priceExc'));
                priceInc += parseFloat($(this).data('priceInc'));
                optionalExtras.push({
                    id: $(this).data('id'),
                    title: $(this).data('title'),
                    price: parseFloat($(this).data('priceExc'))
                });
                optionalExtraIds.push($(this).data('id'));
            }
        });
        $('input[name="optional_extras"]').val(optionalExtraIds.join(','));
        return [priceExc, priceInc];
    };
    this.setVariationPrice = function () {
        var simpleProduct = $('.simple_product_form').length;
        if (products.currentVariation == null && !simpleProduct) {
            return;
        }
        var priceExc = (products.currentVariation != null ? products.currentVariation.price_exc : ''),
            priceInc = (products.currentVariation != null ? products.currentVariation.price_inc : ''),
            displayPriceExc = (products.currentVariation != null ? products.currentVariation.display_price : ''),
            displayPriceInc = parseFloat(displayPriceExc * 1.2),
            wasPriceExc = (products.currentVariation != null ? products.currentVariation.display_regular_price : ''),
            wasPriceInc = parseFloat(wasPriceExc * 1.2),
            minQty = (products.currentVariation != null ? products.currentVariation.min_qty : '');

        $('.product-add-to-basket-cols__col--qty-price').addClass('hide');

        $('.product-add-to-basket-cols__col--qty-price').attr('data-price-exc', displayPriceExc);
        $('.product-add-to-basket-cols__col--qty-price').attr('data-price-inc', displayPriceInc);

        $('.product-add-to-basket-cols__col-price--exc span.price--regular').attr('data-original-number', displayPriceExc);
        $('.product-add-to-basket-cols__col-price--inc span.price--regular').attr('data-original-number', displayPriceInc);
        $('.product-add-to-basket-cols__col-price--exc span.price--sale').attr('data-original-number', priceExc);
        $('.product-add-to-basket-cols__col-price--inc span.price--sale').attr('data-original-number', priceInc);

        $('.saving').hide();

        if (displayPriceExc != wasPriceExc) {

            $('.saving').show();
            $('.product-add-to-basket-cols__col-price--exc span.price--was').attr('data-original-number', wasPriceExc);
            $('.product-add-to-basket-cols__col-price--inc span.price--was').attr('data-original-number', wasPriceInc);

        }

        $('.per-item__price').attr('data-original-number', '');
        if (minQty > 1) {
            $('.per-item__price').attr('data-original-number', displayPriceExc);
        }

        this.setQuantityPrice();
    };
    this.doUnsetVariationImage = function () {
        $('.product__image-gallery-link').removeClass('product__image-gallery-link--muted').eq(0).trigger('mouseover');
    };
    this.setVariationImage = function () {
        //this.doUnsetVariationImage();
        if ($('.product__image-gallery-link[data-image-id="' + products.currentVariation.image_id + '"]').length) {
            $('.product__image-gallery-link').not('[data-image-id="' + products.currentVariation.image_id + '"]').addClass('product__image-gallery-link--muted');
            $('.product__image-gallery-link[data-image-id="' + products.currentVariation.image_id + '"]').eq(0).removeClass('product__image-gallery-link--muted').trigger('mouseover');
            this.setVariationImageCaption();
        }
    };
    this.setVariationImageCaption = function () {
        var attributes = products.currentVariation.attributes,
            html = [];
        if (!attributes) {
            $('.product__images-image-caption').addClass('hide');
            return;
        }
        $.each(attributes, function (index, value) {
            var key = index.split('attribute_pa_')[1];
            if (typeof (key) !== 'undefined') {
                key = key.split(/-(.+)/)[1];
            } else {
                key = index.split('_')[1];
            }
            var value = value.replace(/-/g, ' ');
            if (typeof (key) == 'undefined') {
                var lastIndex = index.lastIndexOf('_'),
                    key = index.substring(lastIndex+1);
            }
            key = key.replace(/-/g, ' ');
            html.push('<span><strong>' + key + ':</strong>&nbsp;' + value + '</span>');
        });
        $('.product__images-image-caption').html(html.join('')).removeClass('hide');
    };
    this.setVariationSku = function () {
        if (products.currentVariation != null) {
            $('.product__code span').html(products.currentVariation.sku);
        } else {
            $('.product__code span').html($('.product__code').data('productSku'));
        }
    };
    this.setVariationDueDate = function () {
        if(products.currentVariation == null) {
            $('.product__due-back-insock-variant').html('');
            return;
        }
        if (products.currentVariation.due_back_in_stock != null) {
            var preFormatDate = new Date(products.currentVariation.due_back_in_stock);
            var date = preFormatDate.getDate() + "/" + (preFormatDate.getMonth()+1) + "/" + preFormatDate.getFullYear();
            $('.product__due-back-insock-variant').html('<br>Due back in stock: '+ date);
        } else {
            $('.product__due-back-insock-variant').html('');
        }
    };
    this.setVariationDimensions = function () {
        if ($('.product-dimensions').length) {
            $('.product-dimensions__item').addClass('hide');
            if (products.currentVariation != null) {
                if ($('.product-dimensions__item[data-variation-id="' + products.currentVariation.variation_id + '"]').length) {
                    $('.product-dimensions__item[data-variation-id="' + products.currentVariation.variation_id + '"]').removeClass('hide');
                } else {
                    $('.product-dimensions__item--all').removeClass('hide');
                }
            } else {
                $('.product-dimensions__item--none').removeClass('hide');
            }
        }
    };
    this.setOptionalExtras = function () {
        var variation_id = this.currentVariation.variation_id,
            variation_ids;
        $('.optional-extras').find('.form-checkbox__checkbox').each(function () {
            variation_ids = $(this).data('variation-ids').toString();
            if (variation_ids.length) {
                variation_ids = variation_ids.split(',');
                variation_ids = variation_ids.map(function (item) {
                    return parseInt(item);
                });
            } else {
                variation_ids = [];
            }
            if (!variation_ids.length || (variation_ids.length && variation_ids.indexOf(variation_id) != -1)) {
                $(this).parent().removeClass('hide');
            } else {
                $(this).prop('checked', false).trigger('change').parent().addClass('hide');
            }
        });
        if ($('.optional-extras').find('.form-checkbox:not(.hide)').length) {
            $('.optional-extras').find('label').removeClass('hide');
        } else {
            $('.optional-extras').find('label').addClass('hide');
        }
    };
    this.setVariationMinQty = function () {
        var $quantity = $('.quantity').find('input[name="quantity"]');
        if (this.productMinimumQuantity == null) {
            this.productMinimumQuantity = parseInt($quantity.attr('min'));
        }
        var minimumQuantity = (products.currentVariation == null ? this.productMinimumQuantity : products.currentVariation.min_qty);
        $quantity.attr('min', minimumQuantity).trigger('change');
        if (minimumQuantity > 1) {
            $('.per-item').removeClass('hide');
            $('.per-item__minQty--value').html(minimumQuantity);
        } else {
            $('.per-item').addClass('hide');
            $('.per-item__minQty--value').html('');
        }
    };
    this.setQuantityPrice = function () {
        var simpleProduct = $('.simple_product_form').length;
        if (products.currentVariation == null && !simpleProduct) {
            return;
        }
        var priceExc = (simpleProduct ? parseFloat($('.product-add-to-basket-cols__col--qty-price').attr('data-price-exc')) : parseFloat(products.currentVariation.display_price)),
            priceInc = (priceExc ? parseFloat($('.product-add-to-basket-cols__col--qty-price').attr('data-price-inc')) : parseFloat(products.currentVariation.price_inc)),
            originalPriceExc = (simpleProduct ? parseFloat($('.product-add-to-basket-cols__col--qty-price').attr('data-price-original')) : parseFloat(products.currentVariation.display_regular_price)),
            originalPriceInc = (originalPriceExc ? originalPriceExc * 1.2 : ''),
            qty = parseInt($('form.cart').find('input.qty').val()),
            optionalExtrasPrice = products.getOptionalExtrasPrice(),
            minQty = (products.currentVariation) ? parseInt(products.currentVariation.min_qty) : parseInt($('form.cart').find('input.qty').attr('min'));
        priceExc += optionalExtrasPrice[0];
        priceInc += optionalExtrasPrice[1];
        priceExc *= qty;
        priceInc *= qty;
        if (typeof (callForPricing) != 'undefined' && callForPricing == 0) {
            if (priceExc > 0) {
                $('.product-add-to-basket-cols__col--qty-price').removeClass('hide');
                $('.product-add-to-basket-cols__col-price--exc, .product-add-to-basket-cols__col-price--inc').addClass('hide');
                if ($('.product-add-to-basket-cols__col--qty-price').attr('data-price-exc') != originalPriceExc) {
                    saving = format.number(parseFloat(originalPriceExc - $('.product-add-to-basket-cols__col--qty-price').attr('data-price-exc')) * qty);
                    $('.total-saving').attr('data-original-number', saving);

                    originalPriceExc += optionalExtrasPrice[0];
                    originalPriceInc += optionalExtrasPrice[1];
                    originalPriceExc *= qty;
                    originalPriceInc *= qty;

                    $('.product-add-to-basket-cols__col-price--exc').find('span.price--sale').html('&#163;' + format.number(priceExc)).attr('data-original-number', priceExc);
                    $('.product-add-to-basket-cols__col-price--inc').find('span.price--sale').html('&#163;' + format.number(priceInc)).attr('data-original-number', priceInc);
                    $('.product-add-to-basket-cols__col-price--exc').find('span.price--was').html('&#163;' + format.number(originalPriceExc)).attr('data-original-number', originalPriceExc);
                    $('.product-add-to-basket-cols__col-price--inc').find('span.price--was').html('&#163;' + format.number(originalPriceInc)).attr('data-original-number', originalPriceInc);

                    $('.product-add-to-basket-cols__col-price--exc span.price--regular, .product-add-to-basket-cols__col-price--inc span.price--regular').addClass('hide');
                    $('.product-add-to-basket-cols__col-price--exc span.price--sale, .product-add-to-basket-cols__col-price--exc span.price--was').removeClass('hide');
                    $('.product-add-to-basket-cols__col-price--inc span.price--sale, .product-add-to-basket-cols__col-price--inc span.price--was').removeClass('hide');

                    if (minQty > 1) {
                        $('.exc-vat').find('span.price--sale').html('&#163;' + format.number(priceExc)).attr('data-original-number', priceExc);
                        $('.inc-vat').find('span.price--sale').html('&#163;' + format.number(priceInc)).attr('data-original-number', priceInc);
                        $('.exc-vat').find('span.price--was').html('&#163;' + format.number(originalPriceExc)).attr('data-original-number', originalPriceExc);
                        $('.inc-vat').find('span.price--was').html('&#163;' + format.number(originalPriceInc)).attr('data-original-number', originalPriceInc);                   

                        $('.exc-vat span.price--regular, .inc-vat span.price--regular').addClass('hide');
                        $('.exc-vat span.price--sale, .exc-vat span.price--was').removeClass('hide');
                        $('.inc-vat span.price--sale, .inc-vat span.price--was').removeClass('hide');     
                    } else {
                        $('.product-add-to-basket-cols__col-price--exc, .product-add-to-basket-cols__col-price--inc').removeClass('hide');
                    }
                } else {
                    $('.product-add-to-basket-cols__col-price--exc').find('span.price--regular').html('&#163;' + format.number(priceExc)).attr('data-original-number', priceExc);
                    $('.product-add-to-basket-cols__col-price--inc').find('span.price--regular').html('&#163;' + format.number(priceInc)).attr('data-original-number', priceInc);

                    $('.product-add-to-basket-cols__col-price--exc span.price--regular, .product-add-to-basket-cols__col-price--inc span.price--regular').removeClass('hide');
                    $('.product-add-to-basket-cols__col-price--exc span.price--sale, .product-add-to-basket-cols__col-price--exc span.price--was').addClass('hide');
                    $('.product-add-to-basket-cols__col-price--inc span.price--sale, .product-add-to-basket-cols__col-price--inc span.price--was').addClass('hide');

                    if (minQty > 1) {
                        $('.exc-vat').find('span.price--regular').html('&#163;' + format.number(priceExc)).attr('data-original-number', priceExc);
                        $('.inc-vat').find('span.price--regular').html('&#163;' + format.number(priceInc)).attr('data-original-number', priceInc);
    
                        $('.exc-vat span.price--regular, .inc-vat span.price--regular').removeClass('hide');
                        $('.exc-vat span.price--sale, .exc-vat span.price--was').addClass('hide');
                        $('.inc-vat span.price--sale, .inc-vat span.price--was').addClass('hide');

                    } else {
                        $('.product-add-to-basket-cols__col-price--exc, .product-add-to-basket-cols__col-price--inc').removeClass('hide');
                    }
                }
            } else {
                $('.product-add-to-basket-cols__col--qty-price').addClass('hide');
            }
        }
        reality.doReplaceCurrencies();
    };
    this.doHideTabs = function () {
        $('.product-tabs__tab').removeClass('product-tabs__tab--selected');
        $('.product-tab-content__tab-button').removeClass('product-tab-content__tab-button--selected');
        $('.product-tab-content__tab').removeClass('product-tab-content__tab--selected');
    };
    this.doHashChange = function (event) {
        var hash = location.hash.replace('#', '');
        if ($('.product-tab-content__tab-button[data-tab="' + hash + '"]').length) {
            this.doHideTabs();
            $('.product-tabs__tab[data-tab="' + hash + '"]').addClass('product-tabs__tab--selected');
            $('.product-tab-content__tab-button[data-tab="' + hash + '"]').addClass('product-tab-content__tab-button--selected');
            $('.product-tab-content__tab[data-tab="' + hash + '"]').addClass('product-tab-content__tab--selected');
        }
    };
    this.doDescriptionLineCount = function() {
        var el = $('.product-detail-summary'),
            characterCount = el.text().length;
        
        if(!el.hasClass('collapsed') && el.find('a.read-more').length) {
            return;
        }
        if(characterCount > 1000) {
            el.addClass('collapsed');
            el.append('<a href="#readmore" class="read-more" title="Read more">+<span class="screen-reader">Read more</span></a>');
        }
    }
    this.expandDescription = function() {
        var el = $('.product-detail-summary');
        if(el.hasClass('collapsed')) {
            var readMore = el.find('a.read-more');
            
            el.removeClass('collapsed');
            readMore.hide();
        }
    }
    this.setTab = function (event, el) {
        if (location.hash == '#' + $(el).data('tab')) {
            history.pushState('', document.title, window.location.pathname + window.location.search);
            this.doHideTabs();
        } else {
            location.hash = '#' + $(el).data('tab');
        }
    };
    this.doNavItemSlider = function(el) {
        var left = el.position().left,
            top = el.position().top,
            right = el.position().right,
            bottom = el.position().bottom,
            width = el.outerWidth();
        $('.nav-item-slider').css({
            'left': left,
            'top': top,
            'right': right,
            'bottom': bottom,
            'width': width
        });
    };
    this.setImage = function (event, el) {
        var $imageWrapper = $('.product__images-image'),
            hasHref = $(el).attr('href');
        $('.product__image-gallery-link').removeClass('product__image-gallery-link--selected');
        $(el).addClass('product__image-gallery-link--selected');
        if (hasHref) {
            $imageWrapper.find('.product__images-image-link').attr('href', $(el).attr('href')).attr('data-enlargeable', $(el).attr('href')).addClass('enlargeable');
            $imageWrapper.attr('data-zoom-url', $(el).attr('href'));
            products.setZoom();
        } else {
            $imageWrapper.find('.product__images-image-link').removeAttr('href').removeClass('enlargeable');
            $imageWrapper.removeAttr('data-zoom-url');
            products.doRemoveZoom();
        }
        if (typeof $(el).data('variationTitle') != 'undefined') {
            $('.product__images-image-caption').html($(el).data('variationTitle')).removeClass('hide');
        } else {
            $('.product__images-image-caption').html('').addClass('hide');
        }
        $imageWrapper.find('img').attr('src', $(el).data('image')).attr('alt', $(el).data('alt'));
    };
    this.setProductView = function () {
        data.doInitialiseSlickCarousels();
    };
    this.setLightboxLinks = function () {
        var mobile = $(window).width() < 566;
        $('a.enlargeable').each(function () {
            $(this).attr('data-enlargeable', $(this).attr('href'));
        });
        $('a[data-enlargeable]').each(function () {
            if (mobile) {
                $(this).removeAttr('href').removeClass('enlargeable');
            } else {
                $(this).attr('href', $(this).attr('data-enlargeable')).addClass('enlargeable');
            }
        });
    };
    this.showOptionalExtraTooltip = function (el) {
        var size = 250,
            thumbnailSize = 36,
            offset = $(el).offset(),
            image = $(el).data('image'),
            isMobile = $(window).width() < 991;
        
        if (isMobile || image.includes('no-image')) {
            return;
        }

        var screenRelativeTop = offset.top - (window.scrollY || window.pageYOffset || document.body.scrollTop);
        
        // Check if the tooltip goes off edge of screen
        if (screenRelativeTop - size - 14 < 0) {
            $('.optional-extras-tooltip').removeClass('hide')
            .css('backgroundImage', 'url("' + image + '")')
            .css('top', screenRelativeTop + thumbnailSize + 14)
            .css('left', offset.left - ((size - thumbnailSize) / 2))
            .addClass('arrow-top');
        } else {
            $('.optional-extras-tooltip').removeClass('hide arrow-top')
            .css('backgroundImage', 'url("' + image + '")')
            .css('top', screenRelativeTop - size - 14)
            .css('left', offset.left - ((size - thumbnailSize) / 2))
        }
    };
    this.hideOptionalExtraTooltip = function () {
        $('.optional-extras-tooltip').addClass('hide');
    };
    this.setColourOptionDropdowns = function () {
        var variationId = parseInt($('.variations_form').find('input[name="variation_id"]').val()),
            html = '';
        $('.colour-option').remove();
        // Set the options based on the variations first where they match the current variation
        if (variationId > 0) {
            $.each(colourOptions, function (index, option) {
                // var enabled = (option.enabled === undefined) ? true : option.enabled;
                // if(enabled) {
                    if (option.variations.length && option.variations.indexOf(variationId) != -1) {
                        html += products.getColourOptionDropdown(index, option);
                    }
                // }
            });
        }
        // Add product level
        if (!html.length) {
            $.each(colourOptions, function (index, option) {
                // var enabled = (option.enabled === undefined) ? true : option.enabled;
                // if(enabled) {
                    if (!option.variations.length) {
                        html += products.getColourOptionDropdown(index, option);
                    }
                // }
            });
        }
        $('.colour-options').append(html);
        reality.setLazyLoadedImages();
    };
    var availableColoursArr = [];
    this.getColourOptionDropdown = function (index, option) {
        var html = '<div class="form-group colour-option">' +
                '<label>' + option.title + '</label>' +
                '<button data-click="products:showColourOptions" data-index="' + index + '" class="colour-options__button">',
            colours,
            swatchSpaces = 5,
            colourSwatchesHTML = '';

        $.each(colourOptions[index].groups, function (groupIndex, group) {
            colours = products.getGroupColours(index, groupIndex, group);
            availableColoursArr.push(colours);
        });

        var plusColours = availableColoursArr.flat(1).length - swatchSpaces;

        availableColoursArr.flat(1).slice(0, swatchSpaces - 1).map(function (i) {
            colourSwatchesHTML += '<span class="colour-options__swatch-previews-swatch reality-lazy-load" data-image-src="' + products.getImage(i.image) + '" title="' + i.title + '"></span>';
        });
        availableColoursArr.flat(1).slice(swatchSpaces - 1, swatchSpaces).map(function (i) {
            if (plusColours !== 0) {
                colourSwatchesHTML += '<span class="colour-options__swatch-previews-plus reality-lazy-load" data-image-src="' + products.getImage(i.image) + '" title="' + i.title + '"><span class="colour-options__swatch-previews-plus--text">+' + plusColours + '</span></span>';
            } else {
                colourSwatchesHTML += '<span class="colour-options__swatch-previews-swatch reality-lazy-load" data-image-src="' + products.getImage(i.image) + '" title="' + i.title + '"></span>';
            }
        });

        html += '<span class="colour-options__swatch-previews">';
        html += colourSwatchesHTML;
        html += '</span></button></div>';

        availableColoursArr = [];
        return html;
    };
    this.setAddToBasketStatus = function () {
        if (typeof products.currentVariation == 'undefined' || products.currentVariation.is_in_stock) {
            $('.form-group.colour-option, .form-group.optional-extras, .product-add-to-basket__footer').removeClass('hide');
            $('.product-add-to-basket__out-of-stock').addClass('hide');
            var variableProduct = $('.variations_form').length,
                variationId = parseInt($('.variations_form').find('input[name="variation_id"]').val()),
                optionsSet = true;
            if (!variableProduct || variationId > 0) {
                $.each(colourOptions, function (index, option) {
                    // Only show check if if all variations or the current is selected
                    // if (!option.variations.length || !option.enabled || (option.variations.length && option.variations.indexOf(variationId) != -1)) {
                    if (!option.variations.length || (option.variations.length && option.variations.indexOf(variationId) != -1)) {
                        if (typeof products.selectedOptions[index] == 'undefined') {
                            optionsSet = false;
                            return false;
                        }
                    }
                });
            }
            if (optionsSet) {
                // Format the options stored in the cart meta data
                products.savedColourOptions = [];
                var groupIndex,
                    colour,
                    colourGroup,
                    selectedOption;
                $.each(colourOptions, function (index, option) {
                    if (variationId > 0) {
                        if (typeof products.selectedOptions[index] != 'undefined' && typeof products.selectedOptions[index][variationId] != 'undefined') {
                            selectedOption = products.selectedOptions[index][variationId];
                        } else {
                            selectedOption = null;
                            products.selectedOptions[index] = {};
                        }
                    } else {
                        selectedOption = products.selectedOptions[index];
                    }
                    if (selectedOption) {
                        groupIndex = selectedOption.groupIndex;
                        colourGroup = colourGroups[option.groups[groupIndex].group];
                        colour = products.getColour(selectedOption.colour, colourGroups[option.groups[groupIndex].group].colours);
                        products.savedColourOptions.push({
                            title: option.title,
                            group: colourGroups[option.groups[groupIndex].group].title,
                            colour: colour.title,
                            colourImage: colour.image,
                            colourCode: colour.code,
                            colourId: selectedOption.colour
                        });
                    }
                });
                $('.variations_form, .simple_product_form').find('input[name="colour_options"]').val(JSON.stringify(products.savedColourOptions));
            } else {
                $('.variations_form, .simple_product_form').find('input[name="colour_options"]').val('');
            }
        } else {
            $('.form-group.colour-option, .form-group.optional-extras, .product-add-to-basket__footer').addClass('hide');
            $('.product-add-to-basket__out-of-stock').removeClass('hide').html(products.currentVariation.availability_html);
        }
        var colour_options = $('form.cart input[name=colour_options]').val();
        var formColourOption = $('.form-group.colour-option');
        var variationColourOptionsEmpty = $('form.cart .variations.colour-options');
        if (formColourOption.length && colour_options.length == 2 || !colour_options.length) {
            $('.single_add_to_cart_button').addClass('disabled').prop('disabled', true);
        } else {
            $('.single_add_to_cart_button').removeClass('disabled').prop('disabled', false);
        }
        if(variationColourOptionsEmpty.is(':empty') || !formColourOption.length) {
            $('.single_add_to_cart_button').removeClass('disabled').prop('disabled', false);
        }
    };
    this.productOptionsToolTip = function () {
        //Displays a tip if user tries to 'add to cart' without selecting the required options
        $('.add_to_basket').mouseenter(function () {
            if ($(".single_add_to_cart_button").is(":disabled")) {
                $('.add-to-cart-tip').css("visibility", "visible");
            }
        }).mouseleave(function () {
            if ($(".single_add_to_cart_button").is(":disabled")) {
                $('.add-to-cart-tip').css("visibility", "hidden");
            }
        });
    };
    this.doHideToolTip = function () {
        $('.colour-options-tooltip').addClass('hide');
    };
    this.setToolTip = function (el) {
        var size = 200,
            offset = $(el).offset();
        $('.colour-options-tooltip').removeClass('hide').css('backgroundImage', $(el).css('backgroundImage')).css('top', offset.top - size - 14).css('left', offset.left - ((size - 84) / 2));
    };
    this.getGroupColours = function (index, groupIndex, group) {
        if (group.type == 'all') {
            return colourGroups[group.group].colours;
        } else {
            var individualColours = [];
            $.each(colourGroups[group.group].colours, function (key, colour) {
                if (group.colours.indexOf(colour.id) != -1) {
                    individualColours.push(colour);
                }
            });
            return individualColours;
        }
    };
    this.getColour = function (colourId, colours) {
        var foundColour = {};
        $.each(colours, function (key, colour) {
            if (colourId == colour.id) {
                foundColour = {
                    title: colour.title,
                    image: colour.image,
                    code: colour.code
                };
                return false;
            }
        });
        return foundColour;
    };
    this.doCloseColourOptions = function (event, el) {
        $('.colour-options-panel').addClass('hide');
        $('.colour-options__button').removeClass('colour-options__button--selected');
        $('.product-columns__column--1').removeClass('hide');
    };
    this.setColourOptionsTab = function (event, el) {
        var groupIndex = $(el).data('groupIndex');
        $('.colour-options-panel__groups-tab').removeClass('colour-options-panel__groups-tab--selected');
        $('.colour-options-panel__tab').removeClass('colour-options-panel__tab--visible');

        $('.colour-options-panel__groups-tab[data-group-index="' + groupIndex + '"]').addClass('colour-options-panel__groups-tab--selected');
        $('.colour-options-panel__tab[data-group-index="' + groupIndex + '"]').addClass('colour-options-panel__tab--visible');

        // Group dropdown
        $('.colour-options-panel__group-dropdown-list').removeClass('colour-options-panel__group-dropdown-list--open');
        $('.colour-options-panel__group-dropdown-button').removeClass('colour-options-panel__group-dropdown-button--open');
        $('.colour-options-panel__group-dropdown-list-item').removeClass('colour-options-panel__group-dropdown-list-item--selected');
        $('.colour-options-panel__group-dropdown-list-item[data-group-index="' + groupIndex + '"]').addClass('colour-options-panel__group-dropdown-list-item--selected');
        $('.colour-options-panel__group-dropdown-button').html($('.colour-options-panel__group-dropdown-list-item[data-group-index="' + groupIndex + '"]').html());

        var subTitle = $('.colour-options-panel__group-dropdown-list-item[data-group-index="' + groupIndex + '"]').data('subTitle');
        if (subTitle && subTitle.length) {
            $('.colour-options-panel__group-dropdown-sub-title').removeClass('hide').html(subTitle);
        } else {
            $('.colour-options-panel__group-dropdown-sub-title').addClass('hide').html('');
        }
    };
    this.setColourOption = function (event, el) {
        var index = $(el).closest('.colour-options-panel').attr('data-index'),
            groupIndex = $(el).closest('.colour-options-panel__tab').data('groupIndex'),
            variationId = $('.variations_form').find('input[name="variation_id"]').val(),
            html = ''; // To replace button with
        if (!$(el).hasClass('colour-options-panel__tab-colours-button--selected')) {
            if (typeof this.selectedOptions[index] == 'undefined') this.selectedOptions[index] = {};
            if (variationId > 0) {
                this.selectedOptions[index][variationId] = {
                    groupIndex: groupIndex,
                    colour: $(el).data('colourId')
                };
            } else {
                this.selectedOptions[index] = {
                    groupIndex: groupIndex,
                    colour: $(el).data('colourId')
                };
            }
            $('.colour-options-panel__tab-colours-button').removeClass('colour-options-panel__tab-colours-button--selected');
            $(el).addClass('colour-options-panel__tab-colours-button--selected');
            html += '<span class="colour-options__button-colour" style=\'background-image: ' + $(el).find('.colour-options-panel__tab-colours-button-colour').css('backgroundImage') + ';\'></span>';
            html += '<span class="colour-options__button-title">' + $(el).find('.colour-options-panel__tab-colours-button-title').text() + '</span>';
            $('.colour-options').find('button[data-index="' + index + '"]').html(html);
            this.setAddToBasketStatus();
            $('.colour-options-panel__tab-footer-confirm').removeClass('disabled').removeAttr('disabled');
        }
    };
    this.getGroupDropDown = function (index) {
        var html = '',
            firstItem = '',
            firstSubTitle = '',
            item = '',
            variationId = parseInt($('.variations_form').find('input[name="variation_id"]').val()),
            selectedGroup = 0;

        if (typeof this.selectedOptions[index] != 'undefined') {
            if (variationId > 0 && typeof this.selectedOptions[index][variationId] != 'undefined') {
                selectedGroup = this.selectedOptions[index][variationId].groupIndex;
            } else {
                selectedGroup = this.selectedOptions[index].groupIndex
            }
        }

        if (colourOptions[index].groups.length > 1) {
            html += '<ul class="colour-options-panel__group-dropdown-list">';
            $.each(colourOptions[index].groups, function (groupIndex, group) {
                html += '<li data-click="products:setColourOptionsTab" data-group-index="' + groupIndex + '"';
                html += ' class="colour-options-panel__group-dropdown-list-item' + (selectedGroup == groupIndex ? ' colour-options-panel__group-dropdown-list-item--selected' : '') + '"';
                if (colourGroups[group.group].subTitle != null) {
                    html += ' data-sub-title="' + colourGroups[group.group].subTitle + '"';
                }
                html += '>';
                item = '<span class="colour-options-panel__group-dropdown-colours">';
                colours = products.getGroupColours(index, groupIndex, group);
                $.each(colours, function (key, colour) {
                    if (key > 1) {
                        return false;
                    }
                    item += '<span class="colour-options-panel__group-dropdown-colours-colour" style="background-image: url(\'' + products.getImage(colour.image) + '\');"></span>';
                });
                item += '</span>';
                item += colourGroups[group.group].title;
                if (groupIndex == 0) {
                    firstItem = item;
                    firstSubTitle = colourGroups[group.group].subTitle;
                }
                html += item;
                html += '</li>';
            });
            html += '</ul>';
        }
        html = '<div class="colour-options-panel__group-dropdown' + (colourOptions[index].groups.length > 3 ? ' colour-options-panel__group-dropdown--desktop' : '') + '">' +
            '<button class="colour-options-panel__group-dropdown-button" data-click="products:doGroupDropdown">' + firstItem + '</button>' +
            html + '<span class="colour-options-panel__group-dropdown-sub-title' + (firstSubTitle && firstSubTitle.length ? '' : ' hide') + '">' + firstSubTitle + '</span></div>';
        return html;
    };
    this.showColourOptions = function (event, el) {
        var index = $(el).data('index'),
            variationId = parseInt($('.variations_form').find('input[name="variation_id"]').val()),
            html = '<div class="colour-options-panel__header" data-index="' + index + '"><button class="colour-options-panel__header-close" data-click="products:doCloseColourOptions"></button> Choose ' + colourOptions[index].title + '</div>',
            disabledConfirm,
            selectedGroup = 0,
            selectedColour,
            colours;
        if (typeof this.selectedOptions[index] != 'undefined') {
            if (variationId > 0) {
                if (typeof this.selectedOptions[index][variationId] != 'undefined') {
                    selectedGroup = this.selectedOptions[index][variationId].groupIndex;
                    selectedColour = this.selectedOptions[index][variationId].colour;
                }
            } else {
                selectedGroup = this.selectedOptions[index].groupIndex
                selectedColour = this.selectedOptions[index].colour;
            }
        }
        disabledConfirm = (selectedColour && selectedColour.length ? '' : ' disabled');
        $('.colour-options__button').removeClass('colour-options__button--selected');
        $(el).addClass('colour-options__button--selected');
        if (colourOptions[index].groups.length > 1) {
            html += products.getGroupDropDown(index);
            if (colourOptions[index].groups.length < 4) {
                html += '<div class="colour-options-panel__groups">';
                $.each(colourOptions[index].groups, function (groupIndex, group) {
                    html += '<a data-click="products:setColourOptionsTab" data-group-index="' + groupIndex + '"';
                    html += ' class="colour-options-panel__groups-tab' + (selectedGroup == groupIndex ? ' colour-options-panel__groups-tab--selected' : '') + '">';
                    html += '<span class="colour-options-panel__groups-tab-title">' + colourGroups[group.group].title + '</span>';
                    html += '<span class="colour-options-panel__groups-tab-colours">';
                    colours = products.getGroupColours(index, groupIndex, group);
                    $.each(colours, function (key, colour) {
                        if (key > 3) {
                            html += '<span class="colour-options-panel__groups-tab-colours-colour" style="background-image: url(\'' + products.getImage(colour.image) + '\');">';
                            html += '<span class="colour-options-panel__groups-tab-colours-colour-count">+' + (colours.length - 4) + '</span>';
                            html += '</span>';
                            return false;
                        }
                        html += '<span class="colour-options-panel__groups-tab-colours-colour" style="background-image: url(\'' + products.getImage(colour.image) + '\');"></span>';
                    });
                    html += '</span>';
                    if (colourGroups[group.group].subTitle) {
                        html += '<span class="colour-options-panel__groups-tab-sub-title">' + colourGroups[group.group].subTitle + '</span>';
                    }
                    html += '</a>';
                });
                html += '</div>';
            }
        }
        $.each(colourOptions[index].groups, function (groupIndex, group) {
            html += '<div class="colour-options-panel__tab' + (selectedGroup == groupIndex ? ' colour-options-panel__tab--visible' : '') + '" data-group-index="' + groupIndex + '">';
            html += '<div class="colour-options-panel__tab-colours">';
            if (colourGroups[group.group].title && Object.keys(colourOptions[index].groups).length <= 1) {
                html += '<div class="colour-options-panel__tab-title"><h4>' + colourGroups[group.group].title + '</h4></div>';
            }
            if (colourGroups[group.group].information) {
                html += '<div class="colour-options-panel__tab-information">' + colourGroups[group.group].information + '</div>';
            }
            if (colourGroups[group.group].disclaimer) {
                html += '<div class="colour-options-panel__tab-information"><p>' + colourGroups[group.group].disclaimer + '</p></div>';
            }
            $.each(products.getGroupColours(index, groupIndex, group), function (key, colour) {
                html += '<button data-click="products:setColourOption" data-colour-id="' + colour.id + '"';
                html += ' class="colour-options-panel__tab-colours-button' + (colour.id == selectedColour ? ' colour-options-panel__tab-colours-button--selected"' : '') + '">';
                html += '<span class="colour-options-panel__tab-colours-button-colour" style="background-image: url(\'' + products.getImage(colour.image) + '\');">';
                html += '<span class="colour-options-panel__tab-colours-button-colour-icon"></span>'; // Tick icon
                html += '</span>';
                html += '<span class="colour-options-panel__tab-colours-button-title">' + colour.title + '</span>';
                if(colour.code && colour.title !== colour.code) {
                    html += '<span class="colour-options-panel__tab-colours-button-code">' + colour.code + '</span>';
                }
                html += '</button>';
            });
            if (colourGroups[group.group].informationPost) {
                html += '<div class="colour-options-panel__tab-information colour-options-panel__tab-information--bottom">' + colourGroups[group.group].informationPost + '</div>';
            }
            html += '</div>';
            html += '<div class="colour-options-panel__tab-footer">';
            html += '<div class="colour-options-panel__tab-footer-information">';
            if (colourGroups[group.group].informationPost) {
                html += colourGroups[group.group].informationPost;
            }
            html += '</div>';
            html += '<a data-click="products:doCloseColourOptions" class="btn btn-primary colour-options-panel__tab-footer-confirm' + disabledConfirm + '"' + disabledConfirm + '>Confirm selection</a>';
            html += '</div>';
            html += '</div>';
        });
        $('.colour-options-panel').removeClass('hide').html(html).attr('data-index', index);
        $('.product-columns__column--1').addClass('hide');
    };
    this.getImage = function (image) {
        if (image.substr(0, 1) != 'h') {
            if (image.substr(0, 1) != '/') {
                image = '/' + image;
            }
            image = 'https://assets.cafereality.co.uk/uploads' + image.replace('/app/uploads', '');
        }
        return image;
    };
    this.doGroupDropdown = function (event, el) {
        var $list = $(el).parent().find('.colour-options-panel__group-dropdown-list');
        $(el).toggleClass('colour-options-panel__group-dropdown-button--open');
        $list.toggleClass('colour-options-panel__group-dropdown-list--open');
    };
    this.doRemoveZoom = function () {
        if ($('#product-image').length) {
            $('#product-image').trigger('zoom.destroy');
        }
    }
    this.setZoom = function () {
        this.doRemoveZoom();
        if ($('#product-image').length) {
            if (typeof $('#product-image').attr('data-zoom-url') != 'undefined') {
                $('#product-image').zoom({
                    url: $('#product-image').attr('data-zoom-url'),
                    magnify: '1.5'
                });
            }
        }
    };
    this.scrollToVariationImage = function () {
        setTimeout(function () {
            if (!products.currentVariation || !products.currentVariation.image_id) {
                products.doUnsetVariationImage();
                $('.product__image-gallery').slick('slickGoTo', 0);
                return;
            }
            var index = $('.product__image-gallery-link[data-image-id="' + products.currentVariation.image_id + '"]').index('.product__image-gallery-link');
            $('.product__image-gallery').slick('slickGoTo', index);
        }, 100);
    };
    this.checkVariationMadeToOrder = function() {
        var madeToOrderNotice = $('.variation-madeToOrder-notice'),
            leadTimeEl = $('.product__delivery-lead.lead-time'),
            html = '';

        madeToOrderNotice.remove();

        if(products.currentVariation.madeToOrder) {
            var leadTime = products.currentVariation.madeToOrderLeadTime;

            html += '<div class="variation-madeToOrder-notice">';
                html += '<span class="shipping-icon" style="background-image: url(/images/svg/ui/shipping-fast-solid.svg)"></span>';
                html += '<span>The selected variation is a made to order item and has a lead time of ' + leadTime + '</span>';
            html += '</div>';
        }

        leadTimeEl.find('span').html(products.currentVariation.madeToOrder ? ((leadTime.toLowerCase().indexOf("delivery") >= 0) ? products.currentVariation.madeToOrderLeadTime : products.currentVariation.madeToOrderLeadTime + ' delivery') : leadTimeEl.find('span').data('original'));

        $(html).insertBefore('.product-add-to-basket__footer');
    };
};

$(document).on('mouseenter', '.colour-options-panel__tab-colours-button-colour', function (e) {
    products.setToolTip(this);
});
$(document).on('mouseleave', '.colour-options-panel__tab-colours-button-colour', function (e) {
    products.doHideToolTip();
});

$('.variations_form').on('hide_variation', function (event, variation) {
    $('.variations_form').find('.colour-option').addClass('hide');
    products.currentVariation = null;
    products.setVariationPrice();
    products.doUnsetVariationImage();
    products.setVariationSku();
    products.setVariationDimensions();
    products.setVariationMinQty();
    $('.optional-extras').addClass('hide');
    products.scrollToVariationImage();
    products.setVariationDueDate();
});
$('.variations_form').on('show_variation', function (event, variation) {
    products.currentVariation = variation;
    products.setVariationImage();
    products.doCloseColourOptions();
    products.setColourOptionDropdowns();
    products.setVariationPrice();
    products.setVariationSku();
    products.setVariationDimensions();
    products.setOptionalExtras();
    products.setVariationMinQty();
    products.setVariationDueDate();
    products.setAddToBasketStatus();
    products.checkVariationMadeToOrder();
    products.scrollToVariationImage();
});

$(function () {
    // fix for smaller images not zooming
    if ($('#product-image').length && $('#product-image:only-child')) {
        if (typeof $('#product-image').attr('data-zoom-url') != 'undefined') {
            $('#product-image').zoom({
                url: $('#product-image').attr('data-zoom-url'),
                magnify: '1.5'
            });
        }
    }
    setTimeout(function () {
        $(window).on('resize orientationChange', function () {
            if ($(window).width() < 1232) {
                data.doInitialiseSlickCarousels();
            }
            products.setLightboxLinks();
        });
        if (window.location.href.indexOf("/prod/") > -1) {
            $('a.enlargeable').featherlightGallery({
                previousIcon: "<img src='/images/svg/ui/arrow-left-white.svg' alt='Previous' />",
                nextIcon: "<img src='/images/svg/ui/arrow-right-white.svg' alt='Next' />",
                galleryFadeIn: 100, /* fadeIn speed when slide is loaded */
                galleryFadeOut: 100 /* fadeOut speed before slide is loaded */
            });
        }
    }, 200);
    products.setLightboxLinks();
    products.doDescriptionLineCount();
    $(document).on('click', '.product-detail-summary a.read-more', function(e) {
        e.preventDefault();
        products.expandDescription();
    });
    if ($('.product__bullets').length) {
        products.setBullets();
    }
    if ($('.simple_product_form').length || $('.variations_form').length) {
        products.setColourOptionDropdowns();
    }
    if ($('.simple_product_form').length) {
        products.setAddToBasketStatus();
        $('.product__image-gallery-link').eq(0).trigger('mouseover');
        $qty = $('.simple_product_form').find('input[name="quantity"]');
        if (parseInt($qty.val()) >= 1) {
            products.setQuantityPrice();
        }
    }
    // Make the variations trigger a change if selected via a query string
    if ($('.variations_form').length && $('.variations').find('select.form-control').not('[value=""]').length) {
        $('.variations').find('select.form-control').not('[value=""]').trigger('change');
    }
    $(window).on('hashchange', function (event) {
        products.doHashChange(event);
    });
    if (location.hash.length) {
        products.doHashChange(null);
    }
    if ($('.product.type-product').length) {
        products.setProductView();
        setTimeout(() => {   
            products.doNavItemSlider($('.product-tabs__tab--selected'));
        }, 0);
    }
    $('.product-tabs__tab a').click(function() {
        products.doNavItemSlider($(this).parent());
    });   
    $(window).resize(function() {
        if ($('.product.type-product').length) {
            products.doNavItemSlider($('.product-tabs__tab--selected'));
        }
    });
    products.productOptionsToolTip();
    $(document).on('mouseenter', '.optional-extra-thumbnail', function (e) {
        products.showOptionalExtraTooltip(this);
    });
    $(document).on('mouseleave', '.optional-extra-thumbnail', function (e) {
        products.hideOptionalExtraTooltip();
    });
    // Touch device handler for optional extras
    if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
        $(document).on('touchstart', '.optional-extra-thumbnail', function(e) {
            products.showOptionalExtraTooltip(this);
            setTimeout(function() {
                products.hideOptionalExtraTooltip();
            }, 2000);
        });
    }
});